import { render, staticRenderFns } from "./LimitatedPlan.vue?vue&type=template&id=04166067"
import script from "./LimitatedPlan.vue?vue&type=script&lang=js"
export * from "./LimitatedPlan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/myskilliz_new/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('04166067')) {
      api.createRecord('04166067', component.options)
    } else {
      api.reload('04166067', component.options)
    }
    module.hot.accept("./LimitatedPlan.vue?vue&type=template&id=04166067", function () {
      api.rerender('04166067', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/divers/LimitatedPlan.vue"
export default component.exports